import { writable } from 'svelte/store';

/**
 * Store for regenerative content with utility functions for processing
 */
export const regenerativeContentStore = writable('');

/**
 * Updates the regenerative content store
 * @param {string} content - HTML content to store
 */
export function updateRegenerativeContent(content) {
    // Handle null/empty content
    if (!content) {
        regenerativeContentStore.set('');
        return;
    }
    
    // Update the store with the content
    regenerativeContentStore.set(content);
}